// Classification band (swimlane) drawn behind the hierarchy. One per distinct
// band present on the canvas: a tinted full-width strip with the
// classification name(s) at that rank, so the stack is readable at a glance
// and a node's vertical position is self-explaining.
//
// Purely decorative: not selectable, not draggable, no handles, and rendered
// beneath every real node (zIndex set on the node object). The strip's tint is
// the classification's own BackgroundColor at low opacity so node cards keep
// their contrast.

import React from "react";

export default function BandRowNode({ data }) {
  const { label, color, width, height, sublabel, variant } = data;

  // A CATEGORY spans the rows of all its classifications: a soft container
  // with the category name down the left, so Network reads as one region
  // holding several classification rows (switch, router, firewall …).
  if (variant === "category") {
    return (
      <div
        style={{
          width,
          height,
          border: "1px dashed hsl(var(--border))",
          borderRadius: 10,
          background: "hsl(var(--muted))",
          opacity: 0.18,
          pointerEvents: "none",
          position: "relative",
        }}
      >
        <div
          style={{
            position: "absolute",
            left: -4,
            top: 8,
            transform: "rotate(180deg)",
            writingMode: "vertical-rl",
            fontSize: 11,
            fontWeight: 800,
            letterSpacing: ".12em",
            textTransform: "uppercase",
            color: "hsl(var(--foreground))",
            opacity: 0.55,
            whiteSpace: "nowrap",
          }}
        >
          {label}
        </div>
      </div>
    );
  }

  return (
    <div
      style={{
        width,
        height,
        background: color || "hsl(var(--muted))",
        opacity: 0.35,
        borderTop: "1px solid hsl(var(--border))",
        borderRadius: 2,
        pointerEvents: "none",
        position: "relative",
      }}
    >
      <div
        style={{
          position: "absolute",
          left: 10,
          top: 6,
          fontSize: 11,
          fontWeight: 700,
          letterSpacing: ".04em",
          textTransform: "uppercase",
          color: "hsl(var(--foreground))",
          opacity: 0.75,
          whiteSpace: "nowrap",
        }}
      >
        {label}
        {sublabel && (
          <span style={{ marginLeft: 8, fontWeight: 500, textTransform: "none", opacity: 0.7 }}>
            {sublabel}
          </span>
        )}
      </div>
    </div>
  );
}
